module["exports"] = [
  "/5[1-5]##-####-####-###L/",
  "/6771-89##-####-###L/"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/credit_card/mastercard.js
 ** module id = 441
 ** module chunks = 0
 **/